import {
  DTNode,
  DTScheduleNode,
  ScheduleNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';
import {DateRangeStartEnd} from '../../adScheduling/adScheduling.types';

function serializeDateRange(dateRange: DateRangeStartEnd) {
  //setup agent returns date ranges as strings, so we need to convert them to ISO strings
  if (typeof dateRange.start === 'string' && typeof dateRange.end === 'string') {
    return {
      start: dateRange.start,
      end: dateRange.end,
    };
  }

  return {
    start: dateRange.start.toISO(),
    end: dateRange.end.toISO(),
  };
}

export function serializeScheduleNode(node: DTNode, newNode: ServerNode) {
  const scheduleNode = node as DTScheduleNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description ?? ''),
    scheduleType: scheduleNode.scheduleType,
    timezoneSource: scheduleNode.timezoneSource,
    timeZone: scheduleNode.timeZone,
    ...(scheduleNode.randomizeOutputs && {randomizeOutputs: true}),
    outputs: (node.outputs as ScheduleNodeOutputData[]).map((output) => {
      return {
        nodeId: output.nodeId,
        id: output.id,
        dateRange: output.dateRange ? serializeDateRange(output.dateRange) : undefined,
        daysOfWeek: output.daysOfWeek,
        type: output.type,
        name: output.name,
      };
    }),
  };
}
